// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsMeasurementChart2-Mc2Summary-actions-Mc2StatesChangeModal-Mc2StatesChangeModal-module__content--HNKqP {
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: auto;
  height: 100%;
  max-height: 80vh;
  min-height: 200px;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-actions-Mc2StatesChangeModal-Mc2StatesChangeModal-module__section--gO6eI {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-actions-Mc2StatesChangeModal-Mc2StatesChangeModal-module__mainSection--kHt6L {
  flex: 1;
  overflow: auto;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-actions-Mc2StatesChangeModal-Mc2StatesChangeModal-module__label--Xu1BS {
  color: rgba(0, 0, 0, 0.55);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-actions-Mc2StatesChangeModal-Mc2StatesChangeModal-module__statesListBox--lA5YS {
  flex: 1;
  overflow: auto;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-actions-Mc2StatesChangeModal-Mc2StatesChangeModal-module__statesList--csMLU {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsMeasurementChart2/Mc2Summary/actions/Mc2StatesChangeModal/Mc2StatesChangeModal.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;AACF;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAAF;AAGA;EACE,OAAA;EACA,cAAA;AADF;AAIA;EACE,0BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAFF;AAKA;EACE,OAAA;EACA,cAAA;AAHF;AAMA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAJF","sourcesContent":[".content {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  overflow: auto;\n  height: 100%;\n  max-height: 80vh;\n  min-height: 200px;\n}\n\n.section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.mainSection {\n  flex: 1;\n  overflow: auto;\n}\n\n.label {\n  color: rgba(0, 0, 0, 0.55);\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 160%;\n}\n\n.statesListBox {\n  flex: 1;\n  overflow: auto;\n}\n\n.statesList {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-actions-Mc2StatesChangeModal-Mc2StatesChangeModal-module__content--HNKqP`,
	"section": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-actions-Mc2StatesChangeModal-Mc2StatesChangeModal-module__section--gO6eI`,
	"mainSection": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-actions-Mc2StatesChangeModal-Mc2StatesChangeModal-module__mainSection--kHt6L`,
	"label": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-actions-Mc2StatesChangeModal-Mc2StatesChangeModal-module__label--Xu1BS`,
	"statesListBox": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-actions-Mc2StatesChangeModal-Mc2StatesChangeModal-module__statesListBox--lA5YS`,
	"statesList": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-actions-Mc2StatesChangeModal-Mc2StatesChangeModal-module__statesList--csMLU`
};
export default ___CSS_LOADER_EXPORT___;
